var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container",attrs:{"fluid":""}},[_c('VueObjectView',{attrs:{"nowrap":false},model:{value:(_vm.eventData),callback:function ($$v) {_vm.eventData=$$v},expression:"eventData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }